import React, {Fragment, useState, useEffect} from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Link } from "react-router-dom";
import { FaEyeSlash,FaEye,FaRegWindowClose,FaLock } from "react-icons/fa";
import axios from 'axios';




export const Registro = (props) => {
    const history = useHistory();
    const location = useLocation();

    const [messageLogin, setmessageLogin] = useState('');
    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }

    const [formIsInvalid, setformIsInvalid] = useState(false);
    const formIsInvalidChange = (val) => {
        setformIsInvalid(val)
    }

    const [verPass, setVerPass] = useState(false);
    const verPassChange = () => {
        setVerPass(verPass? false : true)
    }

    const [nombreData, setNombreData] = useState(null);
    const nombreChange = (val) => {
        setNombreData(val.target.value)
    }
    const [passData, setPassData] = useState(null);
    const passChange = (val) => {
        setPassData(val.target.value)
    }
 

    const gotoRegistro = async () => {
        try {
            var dataForm = {
                "usuario":nombreData,
                "password": passData
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },  
              };
            await axios.post(`${process.env.REACT_APP_URL_API}auth/login`, dataForm, axiosConfig)
            .then(resLogin => {
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                        messageLoginChange('Nombre de usuario o contraseña incorrectos')
                    }else{
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-idu`, resLogin.data.data.idUsuario) 
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`, resLogin.data.data.usuario) 
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-token`, resLogin.data.data.token) 
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-id`, resLogin.data.data.claveUsuario)
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-email`, resLogin.data.data.email)
                        props.modaToggle(false)
                        formIsInvalidChange(false)
                        props.activateAuth()
                    }
                }else{
                    messageLoginChange('Nombre de usuario o contraseña incorrectos')
                }

            })
              
        } catch (error) {
            //setloaddata(false);
            messageLoginChange('Nombre de usuario o contraseña incorrectos') 
            formIsInvalidChange(true)
        }
    }
      

    return(
        <Fragment>
            <div id="logincontain">
                <div className="row">
                    <div className="col-lg-6 col-md-6 mx-auto" id="column-left">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/foto_registro.png`} className="img-responsive" alt="Curso Upta" />			
                    </div>
                    <div className="col-lg-6 col-md-6 mx-auto" id="column-right">
                        <Link to="/">
                            <img src={`${process.env.PUBLIC_URL}/assets/images/UPTA_logo.png`} alt="UPTA logo" />
                        </Link>
                        <p className="form-text text-muted">Registro</p>
                        <form className="form" onSubmit={(e) =>{ e.preventDefault(); gotoRegistro()}}>
                                    <div className="form-group mb-2 mr-sm-2">
                                        <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="nombre" name="nombre" placeholder="Dirección de email" required  onChange={ nombreChange } /><br/>
                                    </div>
                                    <div className="input-group mb-2 mr-sm-2">
                                        <input type={verPass ? 'text' : 'password' } autoComplete="off" className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  id="inlineFormInputGroupUsername2" placeholder="Contraseña" required  onChange={ passChange } />
                                        <div className="input-group-prepend" onClick={ verPassChange }>
                                            <div className="input-group-text" >
                                                {
                                                    verPass ? <FaEyeSlash /> : <FaEye />  
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <button className="btn btn-primary btn-form" type="submit"  >ACCEDE GRATIS</button>
                                    </div>
                                </form>
                        <p className="form-text text-muted">© UPTA Unión de Profesionales y Trabajadores Autónomos</p>
                    </div>	
                </div>			
            </div>
        </Fragment>
    )

}